//@ts-nocheck
import { useState, useEffect } from 'react';
import Head from 'next/head';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BlogItemsBigSingle } from '@components/BlogitemsBigSingle';
import { CWriting } from '@data/copywriting';

const Entrepreneurs: NextPage = () => {
  const penname = "by G. Martin's";
  const mHouse = "The Martin's House";
  const rStory = '';

  return (
    <>
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[232].title}
        img={CWriting.landing[232].img}
        url={CWriting.landing[232].url}
      />
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[229].title}
        img={CWriting.landing[229].img}
        url={CWriting.landing[229].url}
      />
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[227].title}
        img={CWriting.landing[227].img}
        url={CWriting.landing[227].url}
      />
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[226].title}
        img={CWriting.landing[226].img}
        url={CWriting.landing[226].url}
      />
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[224].title}
        img={CWriting.landing[224].img}
        url={CWriting.landing[224].url}
      />
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[221].title}
        img={CWriting.landing[221].img}
        url={CWriting.landing[221].url}
      />
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[220].title}
        img={CWriting.landing[220].img}
        url={CWriting.landing[220].url}
      />
      <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[219].title}
        img={CWriting.landing[219].img}
        url={CWriting.landing[219].url}
      />
      {/* <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[218].title}
        img={CWriting.landing[218].img}
        url={CWriting.landing[218].url}
      /> */}
      {/* <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[217].title}
        img={CWriting.landing[217].img}
        url={CWriting.landing[217].url}
      /> */}
      {/* <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[216].title}
        img={CWriting.landing[216].img}
        url={CWriting.landing[216].url}
      /> */}
      {/* <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[215].title}
        img={CWriting.landing[215].img}
        url={CWriting.landing[215].url}
      /> */}
      {/* <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[214].title}
        img={CWriting.landing[214].img}
        url={CWriting.landing[214].url}
      /> */}
      {/* <BlogItemsBigSingle
        heading
        imgBoo
        urlTemp
        mainHead
        byProp
        price
        service="THE HOUSE EDITORIAL"
        title={CWriting.landing[213].title}
        img={CWriting.landing[213].img}
        url={CWriting.landing[213].url}
      /> */}
    </>
  );
};

export default Entrepreneurs;
